import { AxiosResponse } from 'axios';
import { APIConfig, throttle } from 'src/config';
import axiosClient from 'src/utils/axios-client';
import { wait } from 'src/utils/wait';
import saveAs from 'save-as';
import { getTimeStampYearFirst } from 'src/utils/date-format';
import type { S3FileModel } from '../interfaces/common/s3FileUpload';

class S3FileApi {
  async upload(data: S3FileModel, file: any): Promise<AxiosResponse> {
    if (throttle) {
      await wait(throttle);
    }

    const formData = new FormData();

    formData.append('id', data.id);
    formData.append('entityType', data.entityType);
    formData.append('file', file);
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };

    const response = await axiosClient.post('master/s3files/upload', formData, config);

    return response;
  }

  async uploadMultiple(entityType, id, files: any[]): Promise<AxiosResponse> {
    if (throttle) {
      await wait(throttle);
    }

    const formData = new FormData();
    formData.append('id', id);
    formData.append('entityType', entityType);
    for (let i = 0; i < files.length; i++) {
      formData.append('file', files[i]);
    }
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };

    const response = await axiosClient.post('master/s3files/upload/documents', formData, config);

    return response;
  }

  async getAllApks(): Promise<AxiosResponse> {
    const response = await axiosClient.get('master/s3files/apklist');
    return response;
  }

  async getDocumentFile(key: string) {
    const encodedKey = key.replace(/\//g, '%2F');
    const url = `${APIConfig.apiUrl}master/s3files/download/${encodedKey}`;
    const response = await axiosClient.get(url, {
      responseType: 'arraybuffer',
    });
    const blob = new Blob([response.data], { type: 'application/pdf' });
    return URL.createObjectURL(blob);
  }

  async getImageFile(key: string) {
    const encodedKey = key.replace(/\//g, '%2F');
    const url = `${APIConfig.apiUrl}master/s3files/download/${encodedKey}`;
    const response = await axiosClient.get(url, {
      responseType: 'arraybuffer',
    });
    const blob = new Blob([response.data], { type: 'image/*' });
    return URL.createObjectURL(blob);
  }

  async downloadFile(data: any, name: string) {
    const encodedKey = data.key.replace(/\//g, '%2F');
    const url = `${APIConfig.apiUrl}master/s3files/download/${encodedKey}`;
    const response = await axiosClient.get(url, {
      responseType: 'arraybuffer',
    });

    const blob = new Blob([response.data], { type: data.type });
    saveAs(blob, `${name} ${getTimeStampYearFirst(new Date())}.xlsx`);
  }
}

export const s3FileApi = new S3FileApi();
